import classnames from "classnames";

import style from "./style.module.scss";
import type { ColorPickerProps } from "../../types";

const defaultPalette = [
  "#e82614",
  "#E81D64",
  "#9C26B0",
  "#6739B7",
  "#25319b",
  "#2096F3",
  "#02BCD4",
  "#107f4b",
  "#4DAF50",
  "#FFC107",
  "#FF5721",
  "#795648",
  "#617D8C",
  "#111111",
];

function ColorPicker({ value, onChange, palette = defaultPalette }: ColorPickerProps) {
  return (
    <div className={style.container}>
      {palette.map((color) => (
        <button
          key={color}
          type="button"
          style={{
            background: color,
          }}
          className={classnames(style.color, {
            [style.isSelected]: color === value,
          })}
          onClick={() => onChange(color)}
        />
      ))}
    </div>
  );
}

export default ColorPicker;
